import React from 'react';
import ObservationBox from "../../../../../components/observation-box/observation-box.jsx";
import InfoGrid from "../../../../../components/info-grid/info-grid.jsx";

const EncounterJustifyContent = ({ observation }) => {

    const observationInfo = [
        {
            label: null,
            value: observation ?? "",
            valueClassName: 'ml-0!',
            dots: false,
            span: 3
        }
    ]

    if (!observation) return null;

    return (
        <div className="space-y-4 print:break-inside-avoid!">
            <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f] print:text-[19px]!">
                JUSTIFICATIVA
            </h2>

            <InfoGrid title={''} items={observationInfo} columns={3} labelClassName={'text-[#4F4F4F] text-[13px]! print:text-[15px]!'} valueClassName={'print:text-[17px]!'}  className={'px-2!'} contentClassName={'space-y-1'}/>
        </div>
    )
};

export default EncounterJustifyContent;